import { buildModelManager } from "../builder.js";
const DefaultScenarioShareTokenSelection = {
  __typename: true,
  id: true,
  accessCode: true,
  accessCount: true,
  allowEmailToStudent: true,
  cohortId: true,
  createdAt: true,
  createdById: true,
  currentUses: true,
  emailAddresses: true,
  expiresAt: true,
  institutionalDomain: true,
  isActive: true,
  lastAccessedAt: true,
  maxUses: true,
  notes: true,
  notifyInstructorOnSubmit: true,
  scenarioId: true,
  token: true,
  updatedAt: true
};
const modelApiIdentifier = "scenarioShareToken";
const pluralModelApiIdentifier = "scenarioShareTokens";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioShareTokenSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createScenarioShareToken",
    operationReturnType: "CreateScenarioShareToken",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      scenarioShareToken: { required: false, type: "CreateScenarioShareTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "action",
    operationName: "bulkCreateScenarioShareTokens",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateScenarioShareTokensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "action",
    operationName: "updateScenarioShareToken",
    operationReturnType: "UpdateScenarioShareToken",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      scenarioShareToken: { required: false, type: "UpdateScenarioShareTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateScenarioShareTokens",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateScenarioShareTokensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "action",
    operationName: "deleteScenarioShareToken",
    operationReturnType: "DeleteScenarioShareToken",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteScenarioShareTokens",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertScenarioShareToken",
    operationReturnType: "UpsertScenarioShareToken",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      scenarioShareToken: { required: false, type: "UpsertScenarioShareTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateScenarioShareTokenResult": { hasReturnType: false },
      "... on UpdateScenarioShareTokenResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertScenarioShareTokens",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertScenarioShareTokensInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultScenarioShareTokenSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "scenarioShareTokenGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ScenarioShareTokenManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultScenarioShareTokenSelection,
  operations
);
export {
  DefaultScenarioShareTokenSelection,
  ScenarioShareTokenManager
};
//# sourceMappingURL=ScenarioShareToken.js.map
